// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"VerticalSlider_bannerImage__1ancA","noBorder":"VerticalSlider_noBorder__1sfdz"};